import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { Icon } from '../../../../../libs/ui-new/src/comps/IconNew'
import { colors } from '../../util/colors'
import { Products } from '../NavMobile/Products'
import { styles } from './styles'

interface NavItemProps {
  onPress: (data: string) => void
  title: string
  id: string
  color?: ColorOptions | string | Array<ColorOptions | string>
  hide?: boolean
  showArrow?: boolean
  expanded?: boolean
  close?: any
}

const NavItem: FC<NavItemProps> = ({
  onPress,
  title,
  id,
  hide,
  showArrow = false,
  expanded = false,
  close,
  color = colors.HIGHLIGHT,
}: NavItemProps) => {
  if (hide) {
    return null
  }

  const isProductExpanded = expanded && id === 'Products'

  const handleRouting = (): void => {
    onPress(id)
  }
  return (
    <>
      <Box
        {...styles.navItem}
        onPress={handleRouting}
        align={'center'}
        paddingLeft={showArrow ? 33 : 32}
        underlayColor={'TRANSPARENT'}>
        <Text color={'BLACK_21'} fontSize={14} fontFamily={isProductExpanded ? 'jiotype-bold' : 'jiotype-medium'}>
          {title}
        </Text>
        <Spacer size={8} direction={'horizontal'} />
        {showArrow && <Icon id={expanded ? 'ARROW_UP' : 'ARROW_DOWN'} color={color as ColorOptions} size={24} />}
      </Box>
      <Products hide={!isProductExpanded} close={close} />
    </>
  )
}

export default NavItem
